module.exports = __webpack_public_path__ + "fonts/Pretendard-Bold.3657cde.ttf";